import {
  Checkbox,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import TableSkeleton from "components/skeletons/TableSkeleton";
import TablePagination from "components/tablePagination";
import { useState } from "react";
import LeadsTableRow from "./LeadsTableRow";

const LeadsTable = ({
  allLeads,
  handleDelete,
  handleEdit,
  handleView,
  setReload,
  pagination,
  setPagination,
  loading,
  handleTableCheckBox,
  selectedRows,
  statuses,
  handleRestore,
  permissions,
}) => {
  const [openNote, setOpenNote] = useState("");
  const rows = allLeads;
  const columns = [
    { id: "name", label: "Lead Name" },
    { id: "phone", label: "Phone" },
    { id: "followup_date", label: "Followup Date", style: { width: "140px" } },
    { id: "last_note", label: "Last note", style: { width: "190px" } },
    { id: "lead_assignees", label: "Assigned", align: "center" },
    { id: "email", label: "Email" },
    {
      id: "lead_preferred_countries",
      label: "Preferred Countries",
      style: { width: "170px" },
    },
    { id: "lead_status", label: "Status", align: "center" },
    { id: "source", label: "Source", align: "center" },
    {
      id: "action",
      label: "Actions",
      style: { width: "120px" },
      align: "center",
    },
  ];

  return (
    <Paper sx={{ width: "100%", overflow: "hidden", boxShadow: "none" }}>
      {!loading ? (
        <TableContainer
          sx={{ height: "calc(100vh - 257px)", overflowX: "auto" }}
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow
                sx={{
                  "& .MuiTableCell-sizeMedium": {
                    padding: "10px 0px 10px 16px",
                  },
                  "& .MuiTableCell-sizeMedium:first-of-type": {
                    paddingLeft: "8px",
                    paddingRight: "0px",
                  },
                }}
              >
                <TableCell padding="checkbox">
                  <Checkbox
                    disabled={!permissions["bulk action"]}
                    checked={
                      selectedRows?.length === allLeads?.length &&
                      allLeads?.length
                    }
                    onChange={(e) =>
                      handleTableCheckBox("all", e.target.checked)
                    }
                  />
                </TableCell>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={column.style}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows?.map((row) => (
                <LeadsTableRow
                  key={row.id}
                  row={row}
                  columns={columns}
                  span={columns?.length}
                  handleDelete={handleDelete}
                  handleEdit={handleEdit}
                  handleView={handleView}
                  setReload={setReload}
                  setOpenNote={setOpenNote}
                  openNote={openNote}
                  handleTableCheckBox={handleTableCheckBox}
                  selectedRows={selectedRows}
                  statuses={statuses}
                  handleRestore={handleRestore}
                  permissions={permissions}
                />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <TableSkeleton columns={columns} tableHeight="calc(100vh - 257px)" />
      )}
      <TablePagination
        span={columns?.length}
        setReload={setReload}
        pagination={pagination}
        setPagination={setPagination}
      />
    </Paper>
  );
};

export default LeadsTable;
